import { render, staticRenderFns } from "./InvoiceCloudPaperless.vue?vue&type=template&id=38b18065"
import script from "./InvoiceCloudPaperless.vue?vue&type=script&lang=js"
export * from "./InvoiceCloudPaperless.vue?vue&type=script&lang=js"
import style0 from "./InvoiceCloudPaperless.vue?vue&type=style&index=0&id=38b18065&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports